import React, { useEffect } from 'react'

import { 
    useHistory 
} from 'react-router'

import { 
    ComponentsDiv
} from '../Styles/Pages/ResetPasswordStyles'

import { 
    Alert,
    TopBackgroundDiv,
    BottomBackgroundDiv
} from '../Styles/BaseStyles'

import ResetPasswordFields from '../Components/Action/ResetPasswordFields'

import { useSelector, useDispatch } from 'react-redux'

import { reset } from '../Redux/Slices/ResetPasswordSlice'
import { signInInfo } from '../Redux/Slices/LogInSlice'

function ResetPassword(props){
    const dispatch = useDispatch()
    
    let history = useHistory()

    let username = props.match.params.username
    let code = props.match.params.code

    const passwordResetConfirm = useSelector(state => state.resetPassword.passwordResetConfirm)
    const error = useSelector(state => state.resetPassword.error)
    const errorPhrase = useSelector(state => state.resetPassword.errorPhrase)

    if(passwordResetConfirm){
        dispatch(signInInfo({infoPhrase: 'Successfully reset account password'}))
        history.push('/login')
    }

    useEffect(() => {
        if(error){
            const timeId = setTimeout(() => {
                dispatch(reset())
            }, 5000)
            return () => {
                clearTimeout(timeId)
            }
        }
    }, [dispatch,error])

    return (
        <>
            <TopBackgroundDiv />
            <BottomBackgroundDiv />
            {error && <Alert style={{top: "0.5rem", position: "absolute"}}>{errorPhrase}</Alert>}
            <ComponentsDiv>
                <ResetPasswordFields username={username} code={code}/>
            </ComponentsDiv>
        </>
    )
}

export default ResetPassword